import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import Profiles from './Profiles';

import { close, listupdater, loadingflas, open } from '../redux/popupSlice';
import * as APIS from "../utils/service";
import { getMemberinfo, hpHypen, numFormat } from '../utils/utils';
import Checkbox from './Checkbox';


export default function ProductTogetherConfirmPop(props) {

    const {
        setproductdetailflag=() => {},
        setbellshowflag=()=>{},
        setproducttogetherconfirmflag=() => {},
        productIdx=''
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { configdata } = useSelector(s => s.configReducer);
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })
    const [nolistflag, setnolistflag] = useState(false); 
    const [radio1, setradio1] = useState(0);   
    const [checkvalues, setcheckvalues] = useState([]);   

    const [row, setrow] = useState({}); 
    const [customer, setcustomer] = useState({}); 
    const [mediation, setmediation] = useState({}); 
    const [errormsg, seterrormsg] = useState(''); 


    const [detailinfos, setdetailinfos] = useState([
        {viewernames: '보증금', values: '5,000만원'},
        {viewernames: '월세', values: '200만원'},
        {viewernames: '관리비', values: '30만원'},
        {viewernames: '권리금', values: '5,000만원'},
        {viewernames: '실투자금', values: '10,000만원'},
        {viewernames: '매물종류', values: '상가'},
        {viewernames: '건물명', values: '골든프라자'},
        {viewernames: '해당동 총 층', values: '4층'},
        {viewernames: '층 수', values: '1층'},
        {viewernames: '계약면적', values: '100,95㎡(약 30평)'},
        {viewernames: '전용면적', values: '73,87㎡(22평)'},
        {viewernames: '방향기준/방향', values: '북/주된출입구'},
        {viewernames: '건축물용도', values: '제2종근린생활시설'},
        {viewernames: '건축물일자', values: '사용승인 20090908'},
        {viewernames: '입주가능일', values: '협의'},
    ]);   

    const [checkcommentArr, setcheckcommentArr] = useState([
        {numbers: '1.', comment: '상대 중개사가 요청을 수락하면 상대 중개사에게 의뢰인 연락처·특이사항 외 모든 정보가 전달 됩니다.'},
        {numbers: '2.', comment: '공동중개 요청·승낙 시 계약 유무와 별개로 상호간 공동중개 경험을 \'친절함·전문성·협조성\'을 점수로 평가 할 수 있으며 이는 타 중개사가 공동중개를 요청하기 전 점수를 확인할 수 있습니다. (공동중개 진행 여부에 영향을 미칠 수 있음.)'},
        {numbers: '3.', comment: '동일 부동산과의 공동중개가 여러번 진행되어도 평가는 최고점 1개만 적용 되며, 입력 된 평가는 특별한 사유 없이는 작성자 본인 외 수정·삭제가 불가능합니다.'},
        {numbers: '4.', comment: '평가 점수를 조작하기 위한 의도적인 작업이 적발되는 경우 내부 규정에 의거 공동중개 이용에 제한이 생길 수 있습니다.'},
        {numbers: '5.', comment: '악의적인 평가임이 확인되는 경우 별도 문의주시면 내부 규정에 맞는 서류 등을 안내 해드리며, 운영 규정에 따라 해당 평가는 삭제되며 악의적 작성자에게는 이용 제한 등의 불이익이 발생할 수 있습니다.'},
        {numbers: '6.', comment: '후기는 가입 시 입력된 ‘자격증 번호’ 등 ‘개인’에게 영구 저장되므로 이직·신규 개설·이전 개설을 진행하더라도 ‘자격증 번호’에 따른 점수가 노출됩니다.'},
        {numbers: '7.', comment: '따라서, 공동중개를 진행하시면 반드시 상도덕을 지키고 매너있는 협업을 진행해주시기 바랍니다.\n＊ 5건 미만의 경우 점수 등이 노출되지 않습니다'},
    ]); 

    const [matchinglist, setmatchinglist] = useState([
        {buildingnumber: '88700', dates: '23.05.05', buildingtype: '상가', buildingpricetype: '월세', taglist: '삽결살 마포, 은형', priceData: '월세 2,000/200', addrtxt: '마포구 전체, 은평구 전체'},
        {buildingnumber: '88700', dates: '23.05.05', buildingtype: '상가', buildingpricetype: '월세', taglist: '삽결살 마포, 은형', priceData: '월세 2,000/200', addrtxt: '마포구 전체, 은평구 전체'},
    ]);     

    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);
    useEffect(() => {
        rowDataSubmit();
    }, [productIdx]);

    const rowDataSubmit = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = { idx: productIdx }
        console.log(sender);
        APIS.postData('/v1/mediation/get', sender).then(({ data }) => {
            if(data){
                const { item, customer, mediation } = data;

                console.log("??????????????", data);
                setrow(item);
                setcustomer(customer);
                setmediation(mediation);

                let productinfo = {};

                if(mediation?.type*1 === 1){
                    productinfo = customer;
                    setdetailinfos([
                        {viewernames: productinfo?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(productinfo?.price_all_min)}만원 ~ ${numFormat(productinfo?.price_all_max)}만원`},
                        {viewernames: '월세', values: `${numFormat(productinfo?.price_month_min)}만원 ~ ${numFormat(productinfo?.price_month_max)}만원`},
                        //{viewernames: '권리금', values: `${numFormat(productinfo?.price_key_min)}만원 ~ ${numFormat(productinfo?.price_key_min)}만원`},
                        //{viewernames: '실투자금', values: `${numFormat(productinfo?.price_real)}만원`},
                        {viewernames: '희망 층수', values: `${numFormat(productinfo?.item_floor_min)}층 ~ ${numFormat(productinfo?.item_floor_max)}층`},
                        {viewernames: '희망 면적', values: `${numFormat(productinfo?.item_area_min)}㎡ ~ ${numFormat(productinfo?.item_area_max)}㎡`},
                        {viewernames: '희망 연식', values: `${productinfo?.item_year_min}년 ~ ${productinfo?.item_year_max}년`},
                        {viewernames: '입주시기', values: `${productinfo?.in_year} ${productinfo?.in_year_option1 ? '협의가능' : ''}  ${productinfo?.in_year_option2 ? '상관없음' : ''}`},
                    ]);  
                    
                } else {
                    productinfo = customer;
                    setdetailinfos([
                        {viewernames: productinfo?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(productinfo?.price_all_min)}만원 ~ ${numFormat(productinfo?.price_all_max)}만원`},
                        {viewernames: '월세', values: `${numFormat(productinfo?.price_month_min)}만원 ~ ${numFormat(productinfo?.price_month_max)}만원`},
                        {viewernames: '권리금', values: `${numFormat(productinfo?.price_key_min)}만원 ~ ${numFormat(productinfo?.price_key_min)}만원`},
                        {viewernames: '실투자금', values: `${numFormat(productinfo?.price_real)}만원`},
                        {viewernames: '희망 층수', values: `${numFormat(productinfo?.item_floor_min)}층 ~ ${numFormat(productinfo?.item_floor_max)}층`},
                        {viewernames: '희망 면적', values: `${numFormat(productinfo?.item_area_min)}㎡ ~ ${numFormat(productinfo?.item_area_max)}㎡`},
                        {viewernames: '희망 연식', values: `${productinfo?.item_year_min}년 ~ ${productinfo?.item_year_max}년`},
                        {viewernames: '입주시기', values: `${productinfo?.in_year} ${productinfo?.in_year_option1 ? '협의가능' : ''}  ${productinfo?.in_year_option2 ? '상관없음' : ''}`},
                    ]);  

                    // productinfo = item;
                    // setdetailinfos([
                    //     {viewernames: '매물번호', values: productinfo?.idx},
                    //     {viewernames: '주소', values: productinfo?.addr},
                    //     {viewernames: '매물종류', values: category_1_setting?.find(x => x?.values*1 === productinfo?.category_1*1)?.names},
                    //     {viewernames: '건물명', values: productinfo?.title},
                    //     {viewernames: '해당동 총 층', values: productinfo?.building_dong_floor_all+'층'},
                    //     {viewernames: '층 수', values: productinfo?.building_floor+'층'},
                    //     {viewernames: '계약면적', values: `${productinfo?.area_contract}㎡ (약 ${((productinfo?.area_contract*1)/3.3057).toFixed(2)}평)`},
                    //     {viewernames: '토지면적', values: `${productinfo?.area_land}㎡ (약 ${((productinfo?.area_land*1)/3.3057).toFixed(2)}평)`},
                    //     {viewernames: '공급면적', values: `${productinfo?.area_supply}㎡ (약 ${((productinfo?.area_supply*1)/3.3057).toFixed(2)}평)`},
                    //     {viewernames: '전용면적', values: `${productinfo?.area_private}㎡ (약 ${((productinfo?.area_private*1)/3.3057).toFixed(2)}평)`},
                    //     {viewernames: '방향기준/방향', values: `${productinfo?.item_direction_standard}/${productinfo?.item_direction}`},
                    //     {viewernames: '건축물용도', values: productinfo?.item_usage},
                    //     {viewernames: '건축물일자', values: `${productinfo?.item_date_type}/${productinfo?.item_date}`},
                    //     {viewernames: '입주가능일', values: productinfo?.item_move_date + (productinfo?.item_move_type ? `, ${productinfo?.item_move_type}`:"")},
                    // ]);  
                }
                
                // setdetailinfos([
                //     {viewernames: '매매가', values: numFormat(item?.price_sell)+'만원'},
                //     {viewernames: '보증금', values: numFormat(item?.price_all)+'만원'},
                //     {viewernames: '월세', values: numFormat(item?.price_month)+'만원'},
                //     {viewernames: '관리비', values: numFormat(item?.price_maintenance)+'만원'},
                //     item?.price_keymoney && {viewernames: '권리금', values: numFormat(item?.price_keymoney)+'만원'},
                //     {viewernames: '매물종류', values: category_1_setting?.find(x => x?.values*1 === item?.category_1*1)?.names},
                //     {viewernames: '건물명', values: item?.title},
                //     {viewernames: '해당동 총 층', values: item?.building_dong_floor_all+'층'},
                //     {viewernames: '층 수', values: item?.building_floor+'층'},
                //     item?.area_contract && {viewernames: '계약면적', values: `${item?.area_contract}㎡ (약 ${((item?.area_contract*1)/3.3057).toFixed(2)}평)`},
                //     item?.area_land && {viewernames: '토지면적', values: `${item?.area_land}㎡ (약 ${((item?.area_land*1)/3.3057).toFixed(2)}평)`},
                //     {viewernames: '공급면적', values: `${item?.area_supply}㎡ (약 ${((item?.area_supply*1)/3.3057).toFixed(2)}평)`},
                //     {viewernames: '전용면적', values: `${item?.area_private}㎡ (약 ${((item?.area_private*1)/3.3057).toFixed(2)}평)`},
                //     {viewernames: '방향기준/방향', values: `${item?.item_direction_standard}/${item?.item_direction}`},
                //     {viewernames: '건축물용도', values: item?.item_usage},
                //     {viewernames: '건축물일자', values: `${item?.item_date_type}/${item?.item_date}`},
                //     {viewernames: '입주가능일', values: item?.item_move_date},
                // ]); 
                //console.log(item?.my_arr);
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }

    return (
        <>
            <div className='ProductDetailArea' style={{ zIndex: 1003 }}>
                <div>
                    <div className='ProductDetailAreaBG' 
                        // onClick={() => {
                        //     setproducttogetherconfirmflag(false);
                        // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop"> 
                        <div className="ProductpopTitle padding40" style={{ borderBottom: '4px solid #eee', alignItems: 'center', justifyContent: 'center'}}>
                            <span>상대방이 계약 체결 완료를 요청하였습니다.</span>
                        </div>
                        <div className="ProductSendInfos padding32" style={{ borderBottom: '4px solid #eee'}}>
                            {mediation?.finstatus*1 === 1 ?
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 20 
                            }}>
                                {moment(row?.finDate).add(3, 'days').format('YYYY년 MM월 DD일')}까지 선택하지 않는 경우 공동중개가 종료됩니다.<br />
                                미확인으로 인한 종료 시 해당 매물(고객)의 등록 상태가 보류로 전환되며<br />
                                연결 된 모든 공동중개가 종료되므로 확인 즉시 선택하시기 바랍니다.
                            </div>
                            :
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 20 
                            }}>
                                
                                이미 완료된 공동중개 매물(고객)입니다.
                            </div>
                            }
                            <div className="ProductSendInfos " style={{ marginBottom: 20, }} >
                                <div className="fontsize16 bolds">담당자 정보</div>

                                {customer?.user && <Profiles memberinfosData={customer?.user} companyinfos={customer?.user?.compony} Trophyinfo={false} /> }
                            </div>
                                                                                    
                            <div className="fontsize16 bolds">매물정보</div>
                            <div className='infos margint20'>
                                {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                    if(row?.sell_type === '매매'){
                                        if(x?.viewernames === '보증금' || x?.viewernames === '월세'){
                                            return;
                                        }
                                    } else {
                                        if(x?.viewernames === '매매가'){
                                            return;
                                        }
                                    }

                                    if(!x?.viewernames) return;
                                    return (
                                        <div key={i}>
                                            <div style={{ width: 140 }}>{x?.viewernames}</div>
                                            <div>{x?.values}</div>
                                        </div>
                                    );
                                })}
                            </div>                 
                        </div>
                        {/* <div className="ProductSendInfos padding32" >
                            <div className="matchinglist">
                                <div>
                                    <div className="productnumberinfos">
                                        <div className='linedotTxt'>
                                            <span>고객번호 : {customer?.idx}</span>
                                            <span></span>
                                            <span>등록: {moment(row?.create_dt).format('YY.MM.DD')}</span>
                                        </div>                                                
                                    </div>
                                    <div className="productinfos1">
                                        <div className='linedotTxt'>
                                            <span>{category_2_setting?.find(item => item?.values*1 === row?.category_2*1)?.names}</span>
                                            <span></span>
                                            <span>{customer?.sell_type}</span>
                                        </div>                                                
                                    </div>
                                    <div className="productinfos1 styles2" >{customer?.title}</div>
                                    {customer?.sell_type === '월세' ?
                                    <div className="productinfos1 styles1 bolds" >월세 {numFormat(customer?.price_all_min)}~{numFormat(customer?.price_all_max)}/{numFormat(customer?.price_month_min)}~{numFormat(customer?.price_month_max)}</div>
                                    :
                                    <div className="productinfos1 styles1 bolds" >{numFormat(customer?.price_all_min)}만원 ~ {numFormat(customer?.price_all_max)}만원</div>
                                    }
                                </div>
                            </div>
                        </div> */}
                        <div className="ProductSendInfos padding32" >
                            <div 
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                }}
                            >

                                {mediation?.finstatus*1 === 1 ?
                                <>
                                <div style={{ width: 120 }}>
                                    <Button
                                        buttonTxt={'닫기'}
                                        disabled={true} 
                                        onPress={() => { 
                                            setproducttogetherconfirmflag(false);                                    
                                        }}
                                    />                                       
                                </div>
                                <div style={{ width: 'calc(100% - 120px)'}}>
                                    <Button
                                        buttonTxt={'계약체결완료'}
                                        onPress={() => { 

                                            let sender = { idx: mediation?.idx, finstatus: 2, rejectdesc: '' }
                                            dispatch(loadingflas({ loading: true }));
                                            APIS.postData('/v1/mediation/contract', sender).then(({ data }) => {
                                                if(data){
                                                    dispatch(close());
                                                    dispatch(listupdater({ listupdate: true }));
                                                    setbellshowflag(false);
                                                    setproducttogetherconfirmflag(false);
                                                }
                                            }).catch(({ response }) => {
                                                const { data } = response;
                                                dispatch(close());
                                                seterrormsg(data?.msg);
                                                return;
                                            }).finally(() => {
                                                dispatch(loadingflas({ loading: false }));
                                            });   

                                        }}
                                    />     
                                </div>          
                                <div style={{ width: 'calc(100% - 120px)'}}>
                                    <Button
                                        buttonTxt={'계약미체결'}
                                        styles={{ backgroundColor: 'red' }}
                                        onPress={() => { 
                                            const PopComponents = ({rejectdesc, setrejectdesc}) => {
                                                const [prejectdesc, setprejectdesc] = useState(''); 
                                                const [etcreject, setetcreject] = useState(''); 
                                                const [errmsg, seterrmsg] = useState(''); 
                                                const [checkvalues, setcheckvalues] = useState([]);   


                                                return (
                                                    <div className=''>
                                                        <div style={{
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            fontWeight: 700, fontSize: 20, textAlign: 'center', marginBottom: 20 
                                                        }}>
                                                            상대방의 계약 체결 완료 요청에도<br />
                                                            계약 미체결 처리 하시겠습니까?
                                                        </div>
                                                        <div style={{
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 20 
                                                        }}>
                                                            계약 미체결로 처리하는 경우 매물(고객)의 접수 상태와<br />
                                                            연결 된 공동중개가 변경되지 않고 유지됩니다.<br /><br />

                                                            단, 계약 체결이 되었음에도 미체결 처리로 인해 발생되는<br />
                                                            모든 피해의 책임은 계약 미체결 처리한 당사자에게 있음을 알립니다.
                                                        </div>
                                                        <div className='margint20'>
                                                            <Checkbox
                                                                linetype={'checkimg'}
                                                                values={checkvalues}
                                                                setvalues={(e) => {
                                                                    setcheckvalues(e);
                                                                    seterrmsg('');
                                                                }}
                                                                namevalue={[
                                                                    {names: '위 사항에 동의합니다.', values: 0},
                                                                ]}
                                                                fontweights={400}
                                                                fontSizes={12}
                                                                sizes={20}
                                                            />                                
                                                        </div>   
                                                        <div className="input_error">{errmsg}</div>
                                                        <div className="">
                                                            <div className='popbuttons' style={{ marginTop: 20}}>
                                                                <div>
                                                                    <Button
                                                                        disabled={true}
                                                                        buttonTxt={'계약미체결'}
                                                                        styles={{ backgroundColor: 'red' }}
                                                                        onPress={() => { 
                                                                            if(checkvalues?.length === 0){
                                                                                seterrmsg('위 사항에 동의해주세요.');
                                                                                return;
                                                                            }

                                                                            let sender = { idx: mediation?.idx, finstatus: 0, rejectdesc: '' }
                                                                            dispatch(loadingflas({ loading: true }));
                                                                            APIS.postData('/v1/mediation/contract', sender).then(({ data }) => {
                                                                                if(data){
                                                                                    dispatch(close());
                                                                                    dispatch(listupdater({ listupdate: true }));
                                                                                    setbellshowflag(false);
                                                                                    setproducttogetherconfirmflag(false);
                                                                                }
                                                                            }).catch(({ response }) => {
                                                                                const { data } = response;
                                                                                dispatch(close());
                                                                                seterrormsg(data?.msg);
                                                                                return;
                                                                            }).finally(() => {
                                                                                dispatch(loadingflas({ loading: false }));
                                                                            });  

                                                                        }}
                                                                    />                                    
                                                                </div>
                                                                <div >
                                                                    <Button
                                                                        buttonTxt={'닫기'}
                                                                        onPress={() => { dispatch(close()); }}
                                                                    />                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            dispatch(
                                                open({
                                                    component: <PopComponents />,
                                                    title: '',
                                                    button: "취소",
                                                    buttonCencle: "거절",
                                                    titleviewer: false,          
                                                    alert: false,
                                                    alertStyle: {
                                                        width: 600
                                                    }
                                                })
                                            );                                                      
                                        }}
                                    />     
                                </div>   
                                </>
                                :
                                <div style={{ width: '100%' }}>
                                    <Button
                                        buttonTxt={'닫기'}
                                        disabled={true} 
                                        onPress={() => { 
                                            setproducttogetherconfirmflag(false);                                    
                                        }}
                                    />                                       
                                </div>
                                }                 
                            </div>                                              
                        </div>
                        

                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )    
}